import React from "react";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <section className="about-banner">
        <img src="/main/a1.webp" alt="Our Story" />
        <h1 className="about-banner-title">Our Story</h1>
      </section>

      <section className="about-content">
        <div className="about-section">
          <div className="about-section-left">
            <img src="/main/a2.webp" alt="Jewellery design workspace" />
          </div>
          <div className="about-section-right">
            <h2>Hound &amp; Home is jewellery for curious days and familiar places.</h2>
            <p>
              We create approachable pieces shaped by natural textures,
              thoughtful colour and the small details noticed along the way.
              Our collection is designed to feel distinctive without becoming
              difficult to wear.
            </p>
            <p>
              The name pairs the spirit of a hound—curious, loyal and ready to
              explore—with the calm of home. Together they express the balance
              at the heart of our brand.
            </p>
          </div>
        </div>

        <div className="about-section reverse">
          <div className="about-section-left">
            <p>Our design language begins with contrast.</p>
            <p>
              Polished silver sits beside warm gold details; smooth settings
              frame stones with organic colour and inclusions. We prefer forms
              that are clear at first glance and rewarding up close.
            </p>
            <p>
              Natural amber, turquoise, opal, lapis and pearls each have their
              own character. Variations are expected and celebrated rather than
              treated as flaws.
            </p>
            <p>
              Pieces are selected to move easily between everyday routines,
              celebrations and the journeys that connect them.
            </p>
          </div>
          <div className="about-section-right">
            <img src="/main/a3.webp" alt="Natural stones and jewellery tools" />
          </div>
        </div>

        <div className="about-section">
          <div className="about-section-left">
            <img src="/main/a4.webp" alt="Detailed jewellery craftsmanship" />
          </div>
          <div className="about-section-right">
            <p>
              We focus on pieces that feel good in the hand and comfortable in
              wear. Proportion, fastening and finish matter as much as the first
              impression, and every product page explains the materials and
              practical details of its design.
            </p>
          </div>
        </div>

        <div className="about-section reverse">
          <div className="about-section-left">
            <p>
              Hound &amp; Home is built around honest product information,
              responsive service and jewellery with an individual point of
              view. We want choosing a piece to feel considered, personal and
              uncomplicated.
            </p>
            <p>Questions are always welcome at packs@houndandhome.xyz.</p>
          </div>
          <div className="about-section-right">
            <img
              src="/main/a5.webp"
              alt="Hound and Home jewellery presentation"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
